var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAltArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.2471 10.5569L12.5336 6.13661C12.801 5.86079 12.6389 5.3335 12.2866 5.3335H3.7137C3.36142 5.3335 3.19929 5.86079 3.46676 6.13661L7.75322 10.5569C7.89532 10.7035 8.105 10.7035 8.2471 10.5569Z",
    fill: "#171A20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltArrowDown);
export default __webpack_public_path__ + "static/media/alt-arrow-down.45bafbafca8c44c24fb908be015b3025.svg";
export { ForwardRef as ReactComponent };